export const SLOT_LABEL = 'Slot refers to a variable that can be filled with user input or updated with results from action processing';